module.exports = __webpack_public_path__ + "img/蒙版.48a92e75.png";